import * as THREE from 'three';

/**
 * Deep-dispose an Object3D subtree: geometries, materials and any textures they
 * reference. Call before removing the object from the scene so GPU resources are
 * freed and loading a new file does not leak (SPEC §3.1).
 */
export function disposeObject(root: THREE.Object3D): void {
  root.traverse((obj) => {
    const mesh = obj as THREE.Mesh;
    if (mesh.geometry) mesh.geometry.dispose();

    const material = (mesh as THREE.Mesh).material;
    if (material) {
      const materials = Array.isArray(material) ? material : [material];
      for (const m of materials) disposeMaterial(m);
    }
  });
}

function disposeMaterial(material: THREE.Material): void {
  // Dispose every texture-valued property the material holds.
  for (const value of Object.values(material as unknown as Record<string, unknown>)) {
    if (value && (value as THREE.Texture).isTexture) {
      (value as THREE.Texture).dispose();
    }
  }
  material.dispose();
}
